module.exports = __webpack_public_path__ + "img/Icon-block-checkup-32px-blauw.09d7c43c.svg";